import { Check } from "@mui/icons-material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import { Box, Fab, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import themes from "../../themes.json";
import { ThemeNames, useUserContext } from "../UserContext";

const themeNames = Object.keys(themes);

export const ThemeChooser = ({ ...rest }: React.ComponentProps<typeof Box>) => {
  const { themeName, changeThemeName } = useUserContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setTheme = (name: string) => {
    changeThemeName(name as ThemeNames);
    handleClose();
  }

  return (
    <Box {...rest}>
      <Fab color="primary" size="small" onClick={handleMenu}>
        <Brightness4Icon />
      </Fab>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {themeNames.map((name, index) => {
          if (name === themeName) {
            return (
              <MenuItem key={index}>
                <ListItemIcon>
                  <Check />
                </ListItemIcon>
                {name}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem onClick={() => setTheme(name as ThemeNames)} key={index}>
                <ListItemText inset>{name}</ListItemText>
              </MenuItem>
            );
          }
        })}
      </Menu>
    </Box>
  );
};
